/**
 * Created by claudenbach on 1/19/2017.
 */

import { Injectable } from '@angular/core';
import { AppConstants } from '@utils/app.constants';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

@Injectable()
export class LMEditorService {
  listSpec: LMListSpec;

  constructor(
    private lmConditionUtilService: LMConditionUtilService,
    private lmFormatUtilService: LMFormatUtilService
  ) { }

  public isConditionValid(conditions: LMCondition[], dataView: LMDataView): boolean {
    return this.lmConditionUtilService.isValid(conditions, dataView);
  }

  public getDataValue(type: string, val: string | number): string | number {
    const value = {
      [AppConstants.NUMERIC]    : () => this.lmFormatUtilService.numericToData(val).toString(),
      [AppConstants.BCD]        : () => this.lmFormatUtilService.bcdToData(String(val)),
      [AppConstants.TIMESTAMP]  : () => this.lmFormatUtilService.timestampToData(val),
      [AppConstants.YYYYMMDD]   : () => this.lmFormatUtilService.yyyymmToData(val),
      [AppConstants.TIME]       : () => this.lmFormatUtilService.timeToData(val),
      [AppConstants.YYYYMM]     : () => this.lmFormatUtilService.yyyymmToData(val),
      [AppConstants.MMDD]       : () => this.lmFormatUtilService.mmddToData(val),
      [AppConstants.YYYY]       : () => this.lmFormatUtilService.yyyyToData(val),
      default                 : () => val
    };

    return (value[type] || value['default'])();
  }
}
